// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

import {createMachine, type MachineConfig} from "@qualcomm-ui/utils/machine"

import type {InlineNotificationSchema} from "./inline-notification.types.js"

export const inlineNotificationMachine: MachineConfig<InlineNotificationSchema> =
  createMachine<InlineNotificationSchema>({
    actions: {
      invokeOnDismiss({prop}) {
        prop("onDismiss")?.()
      },
    },
    ids: ({bindableId}) => ({
      closeTrigger: bindableId(),
      description: bindableId(),
      heading: bindableId(),
      root: bindableId(),
    }),
    initialState: () => "visible",
    props({props}) {
      return {
        dir: "ltr",
        role: "status",
        ...props,
      }
    },
    states: {
      dismissed: {},
      visible: {
        on: {
          DISMISS: {
            actions: ["invokeOnDismiss"],
            target: "dismissed",
          },
        },
      },
    },
  })
